import React, { useCallback, useEffect } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import clsx from 'clsx';

import { Button } from '../../../../components/index';
import { TimesIcon } from '../../../../components/icon/solid';
import hotKeyConverter from '../../../../utility/keyCodeConverter';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    '&:hover': {
      backgroundColor: palette.cancelAction.background,
    },
  },
  disabled: palette.disabledButton,
  cancelButton: palette.cancelAction,
  buttonIcon: {
    width: '18px',
    height: '18px',
  },
  buttonText: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0.21px',
    textTransform: 'none',
    paddingLeft: '0.25em',
    lineHeight: 'initial',
  },
  panelButton: {
    height: '36px',
    minWidth: '128px',
  },
}), { name: 'ArticleFormReset' });

type Props = {
  reset: () => void;
};

const FormReset = ({ reset }: Props) => {
  const classes = useStyles();

  const resetHandler = useCallback(() => {
    reset();
  }, [reset]);

  useEffect(() => {
    const hotKeyHandler = (event: KeyboardEvent) => {
      if (event.keyCode === hotKeyConverter('esc')) {
        event.preventDefault();
        reset();
      }
    };
    window.addEventListener('keydown', hotKeyHandler);
    return () => {
      window.removeEventListener('keydown', hotKeyHandler);
    };
  }, [reset]);

  return (
    <Button
      type="reset"
      onClick={resetHandler}
      classes={{
        root: classes.root,
        disabled: classes.disabled,
      }}
      className={clsx(classes.cancelButton, classes.panelButton)}
      variant="contained"
      color="default"
    >
      <TimesIcon className={classes.buttonIcon} />
      <span className={classes.buttonText}>Cancel</span>
    </Button>
  );
};

export default FormReset;
